import { useState } from "react";

export const useProductForm = () => {

  const [formData, setFormData] = useState({

    category_id: "",
    subcategory_id: "",

    state_id: "",
    city_id: "",
    location_id: "",
    bed: "",
    title: "",
    description: "",

    price: "",
    // discount_price: "",

    guest: "",
    bedroom: "",
    bed: "",
    bathroom: "",

    address: "",

    latitude: "",
    longitude: "",

    amenities: [],

    status: "active",

    noOfReviews: "",
    rating: "",

    bookingStatus: "0",

    thumbnail_image: null,

    images: [],
  });

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return {
    formData,
    setFormData,
    handleChange,
  };
};